import * as React from 'react';
import { find as _find } from 'lodash';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';
import { Modal } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { Redirect } from 'react-router';
import { setTimeout } from 'timers';
import { cutOuts as getCutOuts, ConfigurationModel, CutOut, getPartDetail, buildCutOutSpec, Configuration } from 'franke-trough-dependencies';
// import TroughImage from '../TroughImage/TroughImage';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './CutOutDisposalModal.messages';

import './CutOutDisposalModal.scss';
import { CutOutLabel } from '../CutOutDisposalSelection';

export interface CutOutDisposalModalProps {
  backUrl: string;
  cutoutId: string;
  configuration: GlobalPrivateState['configuration'];
  userData: GlobalPrivateState['userData'];
}

export interface CutOutDisposalModalState {
  isOpen: boolean; 
  redirect: boolean;
}

export class CutOutDisposalModalPartial extends React.Component<CutOutDisposalModalProps, CutOutDisposalModalState> {
  constructor(props: CutOutDisposalModalProps) {
    super(props);
    this.state = {
      isOpen: false,
      redirect: false,
    };
    this.toggleModal = this.toggleModal.bind(this);
  }

  componentDidMount() {
    this.setState({
      isOpen: true,
    });
  }

  componentDidUpdate() {
    if (!this.state.isOpen && !this.state.redirect) {
      this.setState({
        isOpen: true,
        redirect: false,
      });
    }
  }

  public render() {
    const cutout = this.selectedCutout;
    const parts = cutout && cutout.parts;
    const partsCol = parts && 12 / parts.length || 12;

    const lang: any = this.props.userData && this.props.userData.result && this.props.userData.result.lang.split('-')[0] || 'en';

    return (
      <div className="cutout-disposal-modal">
        <Modal 
          isOpen={this.state.isOpen} 
          backdrop={true}
          toggle={this.toggleModal}
          className="cutout-disposal-modal"
        >
        <div className="modal-inner d-flex justify-content-center align-items-center vh-100">
            <button onClick={this.toggleModal} className="close-btn">
              <FontAwesomeIcon icon={faTimes} />
            </button>
            {cutout && (
              <div className="container">
              <div className="row justify-content-center">
                <div className="col-12 col-md-4 cutout-img">
                  <img src={'/img/cut-outs/'+cutout.key+'.jpg'} alt="Placeholder" width={400} height={400} className="img-fluid" />
                </div>
                <div className="col-12 col-md-8" style={{maxWidth: parts && parts.length === 1 ? 470 : 'none'}}>
                  <div className="cutout-heading w-100 pb-2 border-bottom">
                    <h3><CutOutLabel value={cutout.key} /></h3>
                  </div>
                  <div className="row">
                    {parts && parts.map((part, index) => {
                      return (
                        <div key={`part_name_${index}`} className={`cutout-data pb-2 col-${partsCol}`}>
                          <small className="pt-3"><FormattedMessage {...MESSAGES.cutoutPartDetailName} /></small>
                          <p>{getPartDetail(part, 'name', lang)}</p>
                        </div>
                      )
                    })}
                  </div>
                  <div className="row">
                    {parts && parts.map((part, index) => {
                      return (
                        <div key={`part_dimensions_${index}`} className={`cutout-data pb-2 col-${partsCol}`}>
                          <small className="border-top pt-3"><FormattedMessage {...MESSAGES.cutoutPartDetailDimensions} /></small>
                          <p>{getPartDetail(part, 'dimensions', lang)}</p>
                        </div>
                      )
                    })}
                  </div>
                  <div className="row">
                    {parts && parts.map((part, index) => {
                      return (
                        <div key={`part_type_${index}`} className={`cutout-data pb-2 col-${partsCol}`}>
                          <small className="border-top pt-3"><FormattedMessage {...MESSAGES.cutoutPartDetailType} /></small>
                          <p>{getPartDetail(part, 'part_type', lang)}</p>
                        </div>
                      )
                    })}
                  </div>
                  <div className="row">
                    {parts && parts.map((part, index) => {
                      return (
                        <div key={`part_article_${index}`} className={`cutout-data pb-2 col-${partsCol}`}>
                          <small className="border-top pt-3"><FormattedMessage {...MESSAGES.cutoutPartDetailArticle} /></small>
                          <p>{getPartDetail(part, 'article', lang)}</p>
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
            </div>
            )}
          </div>
        </Modal>
        {this.state.redirect && (
          <Redirect to={this.props.backUrl} />
        )}
      </div>
    );
  }

  private toggleModal(): void {
    this.setState({
      isOpen: false,
    });
    setTimeout(() => this.setState({redirect: true}), 151);
  }

  private get selectedCutout(): CutOut | undefined {
    if (!this.configuration) { return; }

    const conf = new Configuration(this.configuration);
    const cutout = buildCutOutSpec(this.props.cutoutId as any, conf);

    // A cutout could have different parts depending on it's position...
    // So, first we get the positions for the cutout key...
    const builtInParts = this.configuration && this.configuration.builtInParts && this.configuration.builtInParts;

    const positions = cutout.key === 'PROVIDER' ? builtInParts && builtInParts.paperTowelDispensersPosition :
      cutout.key === 'COSMETIC' ? builtInParts && builtInParts.tissueDispenserPosition :
      builtInParts && builtInParts.cutOutDisposalsPosition;
    
    // We only clear the parts if we actually have one added, otherwise we just use the default parts from above
    if (positions && positions.length > 0 && positions.includes(true)) {
      cutout.parts = [];
      for (let i = 0; i < positions.length; i++) {
        // If the position is selected, then build a cutout for that position, and merge it with the existing parts
        if (positions[i] === true) {
          const cutoutAtPosition = buildCutOutSpec(this.props.cutoutId as any, conf, i);
          
          cutout.parts = [...cutout.parts, ...cutoutAtPosition.parts];
          cutout.parts = cutout.parts.filter((item, pos) => cutout.parts.indexOf(item) === pos);
        }
      }
    }

    return cutout;
  }

  private get configuration(): ConfigurationModel | undefined {
    return this.props.configuration && this.props.configuration.result;
  }
}

export const CutOutDisposalModal = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
  userData: state.userData
}))(CutOutDisposalModalPartial);

export default CutOutDisposalModal;